import { render, staticRenderFns } from "./Security_policy.vue?vue&type=template&id=09f82e65&"
import script from "./Security_policy.vue?vue&type=script&lang=js&"
export * from "./Security_policy.vue?vue&type=script&lang=js&"
import style0 from "./Security_policy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports